export const GET_WEATHER = `
query Weather {
  weather {
    racecourse
    sectional {
      location
      date
      time
      avgCorrectedWindDirection
      avgCorrectedWindSpeed
      correctedGustDirection
      correctedGustSpeed
      gpsPosition
      supplyVoltage
      status
      isValid
    }
    weatherStation {
      location
      date
      time
      avgCorrectedWindDirection
      avgCorrectedWindSpeed
      correctedGustDirection
      correctedGustSpeed
      gpsPosition
      supplyVoltage
      relativeHumidity
      temperature
      solarRadiation
      sunshineHour
      pressure
      correctedGustSpeedDailyMax
      relativeHumidityDailyMax
      relativeHumidityDailyMin
      temperatureDailyMax
      temperatureDailyMin
      rainFallPrecipitation1Min
      rainFallPrecipitation10Min
      rainPrecipitationDailyTotal
      soilVolumeticWaterContent
      soilMoistureLoss1Min
      soilMoistureLossDailyTotal
      soilMoistureLoss24H
      status
      isValid
    }
  }
}

  `

export const GET_HEADER_NAV_MAIN = `
  query SiteHeaderNavMain($path: String, $language: String) {
    item(path: $path, language: $language) {
      data: children {
        name
        hasChildren
        label: field(name: "label") {
          ... on TextField {
            value
          }
        }
        link: field(name: "link") {
          ... on TextField {
            value
          }
        }
        seq: field(name: "seq") {
          ... on TextField {
            value
          }
        }
        target: field(name: "newwindow") {
          ... on CheckboxField {
            value
          }
        }
        newwindow: field(name: "newwindow") {
          name
          value 
        }
        children {
          name
          hasChildren
          label: field(name: "label") {
            ... on TextField {
              value
            }
          }
          link: field(name: "link") {
            ... on TextField {
              value
            }
          }
          seq: field(name: "seq") {
            ... on TextField {
              value
            }
          }
          target: field(name: "newwindow") {
            ... on CheckboxField {
              value
            }
          }
          newwindow: field(name: "newwindow") {
            name
            value 
          }
          children {
            name
            hasChildren
            label: field(name: "label") {
              ... on TextField {
                value
              }
            }
            link: field(name: "link") {
              ... on TextField {
                value
              }
            }
            seq: field(name: "seq") {
              ... on TextField {
                value
              }
            }
            target: field(name: "newwindow") {
              ... on CheckboxField {
                value
              }
            }
            newwindow: field(name: "newwindow") {
              name
              value 
            }
            children {
              name
              hasChildren
              label: field(name: "label") {
                ... on TextField {
                  value
                }
              }
              link: field(name: "link") {
                ... on TextField {
                  value
                }
              }
              seq: field(name: "seq") {
                ... on TextField {
                  value
                }
              }
              target: field(name: "newwindow") {
                ... on CheckboxField {
                  value
                }
              }
              newwindow: field(name: "newwindow") {
                name
                value 
              }
            }
          }
        }
      }
    }
  }
  `;

export const GET_HEADER = `
  query SiteHeader($path: String, $language: String) {
    item(path: $path, language: $language) {
      displayName
      HRLabel: field(name: "HRLabel") {
        value
      }
      LeftImage: field(name: "LeftImage") {
        ... on ImageField {
          value
          size
          src
          title
        }
      }
      RightImage: field(name: "RightImage") {
        ... on ImageField {
          value
          size
          src
          title
          alt
        }
      }
      HRRedirectionLink: field(name: "HRRedirectionLink") {
        value
      }
      LeftLink: field(name: "LeftLink") {
        value
      }
      RightLink: field(name: "RightLink") {
        value
      }
      HRRedirectionNewWindow: field(name: "HRRedirectionNewWindow") {
        value
      }
      LeftLinkNewWindow: field(name: "LeftLinkNewWindow") {
        value
      }
      RightLinkNewWindow: field(name: "RightLinkNewWindow") {
        value
      }
      FBLabel: field(name: "FBLabel") {
        value
      }
      FBRedirectionLink: field(name: "FBRedirectionLink") {
        value
      }
      FBRedirectionNewWindow: field(name: "FBRedirectionNewWindow") {
        value
      }
      M6Label: field(name: "M6Label") {
        value
      }
      M6RedirectionLink: field(name: "M6RedirectionLink") {
        value
      }
      M6RedirectionNewWindow: field(name: "M6RedirectionNewWindow") {
        value
      }
    }
  } 
  `;

export const GET_FOOTER_MENU = `
query FooterMenu($language: String, $path: String) { 
  item(language: $language, path: $path) {
    sitemap: field(name: "Sitemap") {
      ... on TextField {
        value
      }
    } 
    bottomlink: field(name: "BottomLink") {
      ... on TextField {
        value
      }
    }
  }
} 
`;

export const GET_RGPBANNER = `  
query RGPBanner($language: String, $path: String) { 
  item(language: $language, path: $path) {
    RGPBanner: field(name: "RGPBanner") {
      ... on TextField {
        rendered 
      }
    }
  }
} 
`;

export const GET_REMARK = `  
query($path: String, $language: String) {
  item(path: $path, language: $language) { 
    ... on Remark{
      remarks { 
        rendered
      }
    }
  }
}
`;
export const GET_WEATHER_MEETING = `
query wt_WeatherMeeting( $localSim: LocalSim, $status: [MeetingStatus!])  {
  commonMeetings(localSim: $localSim, status: $status) {
    date
    venueCode
    meetingTrack_en
    meetingTrack_ch
    status
    totalNumberOfRace
    currentNumberOfRace
     meetingType
     penetrometerReadings {
      reading
      readingTime
      sequenceNumber
    }
    hammerReadings {
      sequenceNumber
      readingTime
      reading
    }
    course {
      code
      chinese
      english
      mandarin
    }
    races {
      go_en
      go_ch
      status
      no
      raceTrack {
        code
      }
    }
  }
}
`;
export const GET_BANNERS = `
query BannerQuery($path:String,$language:String){
  banners:item(path:$path,language:$language){
    bannerList:children{
      imageUrl:field(name:"Banner"){
        ... on ImageField{
          value:src
        }
      }
      imageUrl_Mobile:field(name:"MobileBanner"){
        ... on ImageField{
          value:src
        }
      }
      redirectionLink:field(name:"RedirectionLink"){
        value
      }
      target:field(name:"Target"){
        value
      }
      enabled:field(name:"Enabled"){
        ... on CheckboxField{
          value:boolValue
        }
      }
      description: field(name:"BannerDescription"){
        value
      }
      onlineDatetime:field(name:"OnlineDatetime"){
        sourceDate:value
        ...on DateField{
          value:formattedDateValue(format:"s",offset:-480)
        }
      }
      OfflineDatetime:field(name:"OfflineDatetime"){
        sourceDate:value
        ...on DateField{
          value:formattedDateValue(format:"s",offset:-480)
        }
      }
    }
  }
}
`;
